import React, { useEffect, useState } from "react";
import * as styles from "./AuthView.module.css";
import { Login } from "../../components/Login";
import { SignUp } from "../../components/SignUp";
import { ForgotPassword } from "../../components/ForgotPassword";
import { appConstants } from "../../utils";
import { useLocation, useNavigate } from "react-router-dom";
import * as constant from "../../utils/constants";

const AuthView = ({
  content,
  redirectPath,
  defaultRedirectPath,
  setUserData,
}) => {
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();

  useEffect(() => {
    if (redirectPath) {
      navigate(constant.APP_ROUTE_LOGIN);
    }
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.left_container}>
        {pathname === constant.APP_ROUTE_LOGIN &&
          content?.login &&
          content.login}
        {pathname === constant.APP_ROUTE_SIGNUP &&
          content?.signup &&
          content.signup}
        {pathname === constant.APP_ROUTE_FORGOT_PASSWORD &&
          content?.forgotPassword &&
          content.forgotPassword}
      </div>

      <div className={styles.right_container}>
        <div className={styles.form_container}>
          {pathname === constant.APP_ROUTE_LOGIN && (
            <Login
              onLoginSuccess={(userDetails) => {
                setUserData(userDetails);
                navigate(redirectPath || defaultRedirectPath);
              }}
            />
          )}
          {pathname === constant.APP_ROUTE_SIGNUP && (
            <SignUp
              onLoginSuccess={(userDetails) => {
                setUserData(userDetails);
                navigate(redirectPath || defaultRedirectPath);
              }}
            />
          )}
          {pathname === constant.APP_ROUTE_FORGOT_PASSWORD && (
            <ForgotPassword />
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthView;
